import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';
import { SeoService } from 'src/app/service/seo.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reserch-details',
  templateUrl: './reserch-details.component.html',
  styleUrls: ['./reserch-details.component.css']
})
export class ReserchDetailsComponent implements OnInit {

  research_id
  reserch_details: any = {
    DETAILS: '',
    IMG_PATH: '',
    TITLE: '',
    faculty_name: '',
    LINK: null,
  }
  // "أبحاث أخرى" sidebar — the details API returns no related list, so we
  // surface other researches from the listing (mirrors the news top-read aside).
  otherResearch: any[] = []

  constructor(private rest: RestService, private route: ActivatedRoute, private router: Router, private seo: SeoService) { }

  ngOnInit(): void {
    window.scrollTo(0, 0)
    this.research_id = this.route.snapshot.paramMap.get('id')
    this.getData()
    this.getOtherResearch()
  }

  getData() {
    this.rest.research_detail(this.research_id).subscribe((res: any) => {
      this.reserch_details = res
      this.seo.updateFrom(res)
    })
  }

  getOtherResearch() {
    this.rest.getResearch().subscribe((res: any) => {
      this.otherResearch = (res || []).filter(item => String(item.ID) !== String(this.research_id))
    })
  }

  Details(item) {
    this.router.navigate(['/research_details', item.ID]).then(() => {
      location.reload()
    })
  }

  go_to_list() {
    this.router.navigateByUrl('/research_list')
  }

}
